import { get } from './';

// Unauthenticated v1 list — only for pre-auth flows (SignUp). Authenticated
// consumers use getCatalogCountries below.
export const getCountries = () => get('/api/v1/countries');

// v3 catalog list: flat DTOs ({ id, name, alpha2, currency, phoneCode,
// lat, lon }), name already localized. Response { data, meta } is unwrapped
// so consumers keep reading response.data as an array.
export const getCatalogCountries = () =>
  get('/api/v3/countries?perPage=1000').then(response => ({
    ...response,
    data: response?.data?.data ?? [],
    meta: response?.data?.meta,
  }));

export const getCountriesByDmcId = ({ dmcId, search = '' }) => {
  if (!dmcId) {
    return get(`/api/v1/countries?search=${search}`);
  }

  return get(`/api/v1/countries/${dmcId}?search=${search}`);
};

export const getCountriesByOrganization = ({ organizationId }) =>
  get(`/api/v1/countries/${organizationId}`);

export const getCountriesWithQuery = ({ search }) =>
  get(`/api/v1/countries/search?search=${search ?? ''}`);
